import { SVGProps } from 'react';

export const ShieldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M3 11.3V4.2778L4.51179 4.15781C5.82884 4.05328 7.12135 3.73373 8.34073 3.21112L10 2.5L11.6592 3.21112C12.8786 3.73373 14.1711 4.05328 15.4882 4.15781L17 4.2778V11.3C17 15.2765 13.866 18.5 10 18.5C6.13397 18.5 3 15.2764 3 11.3Z'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.88672 10.4996L8.83115 12.4996L13.1089 8.09961'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
